import cx from 'classnames'

import styles from './checkbox.module.css'

interface Props extends React.ComponentProps<'input'> {
  labelClassName?: string
  label: string
}

export function Checkbox ({ className, checked, disabled, onChange, labelClassName, label }: Props): JSX.Element {
  return (
    <div className={cx(styles.nhCheckboxWrapper, className)}>
      <div className={styles.nhCheckbox}>
        <input
          tabIndex={-1}
          type='checkbox'
          checked={checked}
          disabled={disabled}
          onChange={onChange}
        />
        <label className={cx(labelClassName)}>
          {label}
        </label>
      </div>
    </div>
  )
}
